import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";

import {sideNavData} from "./tileData";
import "./drawer.css";

const styles = {
  list: {
    width: 250
  },
  fullList: {
    width: "auto"
  },
  flex: {
    flex: 1
  }
};

class TemporaryDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.toggleDrawer = (side, open) => () => {
      props.toggleDrawer();
    };
  }

  componentWillReceiveProps(a){

  }

  render() {
    const {classes, state} = this.props;
    const sideList = (
      <div className={classes.list}>
        <div className="myProfileTab">
          <div className="profile-icon-cntr"><img
            alt="profile-icon-cntr"
            src="http://icons.iconarchive.com/icons/seanau/kungfu-panda/256/Panda-icon.png"/></div>
          <div>Piyush Pandey</div>
        </div>
        <Divider/>
        <List>{sideNavData}</List>
        <Divider/>
      </div>
    );

    return (
        <Drawer open={state} onClose={this.toggleDrawer("left", false)}>
          <div
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer("left", false)}
            onKeyDown={this.toggleDrawer("left", false)}>
            {sideList}
          </div>
        </Drawer>
    );
  }
}

TemporaryDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  pagetitle: PropTypes.string,
  state: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func
};

export default withStyles(styles)(TemporaryDrawer);



// WEBPACK FOOTER //
// ./src/components/Drawer/drawer.js